import { SORTING_ORDER_TYPES } from 'taboola-ultimate-ui';
import { isProgrammaticAccount } from 'modules/account-management/accountType';
import { isFeatureAllowedForICPAccount } from 'modules/accounts/utils/isFeatureAllowedForICPAccount';
import { TOP_RESULTS_TYPE } from 'modules/campaigns/constants';
import {
    CONTENT,
    ID,
    SIZE,
    TITLE,
    CREATE_TIME,
    CUSTOM_CREATIVE_NAME,
    TYPE,
} from 'modules/campaigns/modules/campaigns-reports/config/fields';
import * as FIELDS from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { FILTER_TYPE } from 'modules/campaigns/modules/campaigns-reports/config/filters';
import { REPORT_PRESET } from 'modules/campaigns/modules/campaigns-reports/config/pickers';
import { isMsV2WidePerformanceEnabled } from 'modules/campaigns/modules/campaigns-reports/config/reports/creative';
import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import { MODULE_NAME as CREATIVE_LIBRARY_MODULE } from 'modules/creative-library/config/routes';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { bulkActions } from './bulkActions';
import { availableColumnDefinitions } from './columnDefinitions';
import { CREATIVE_LIBRARY_REPORT_ID } from './creativeLibraryReportId';
import { defaultColumns } from './reportPresets';

export const creativeLibraryReportConfig = {
    id: CREATIVE_LIBRARY_REPORT_ID,
    label: 'Creative Library',
    module: CREATIVE_LIBRARY_MODULE,
    endpoint: 'creatives/by_account',
    rowIdField: ID.field,
    columnsDef: availableColumnDefinitions,
    searchPlaceholderMsgId: 'app.reports.openSearchBar.search.placeholder',
    searchField: TITLE.field,
    sortMap: {
        [CONTENT.field]: TITLE.field,
        [SIZE.field]: ['width', 'height'],
        [CREATE_TIME.field]: 'createTimeInUtc',
        [CUSTOM_CREATIVE_NAME.field]: 'name',
        [TYPE.field]: 'creativeType',
    },
    bulkActions,
    filters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            accountConfigurations: {
                [FEATURE_FLAGS.HEAVY_ACCOUNT]: 'false',
                [FEATURE_FLAGS.CREATIVE_REPORT_TOP_RESULTS_FILTER_ACTIVE]: 'true',
                [FEATURE_FLAGS.CREATIVE_REPORT_USE_WIDE_CONFIG_MSV2]: 'false',
            },
        },
        { id: FILTER_TYPE.STATUS },
        { id: FILTER_TYPE.APPROVAL_STATUS, multiSelect: true },
        { id: FILTER_TYPE.CREATION_DATE },
        {
            id: FILTER_TYPE.CREATIVE_MEDIA_TYPE,
            visibilityCondition: ({ selectedAccount, accountConfig, permissionsMap }) =>
                !isProgrammaticAccount(selectedAccount) && isMsV2WidePerformanceEnabled(accountConfig, permissionsMap),
        },
        {
            id: FILTER_TYPE.CREATIVE_LIBRARY_CHANNEL_TYPE,
            visibilityCondition: ({ selectedAccount, accountConfig }) =>
                isFeatureAllowedForICPAccount(selectedAccount, accountConfig, FEATURE_FLAGS.IS_DISPLAY_FILTERS_ENABLED),
        },
        {
            id: FILTER_TYPE.CREATIVE_LIBRARY_FORMAT_TYPE,
            visibilityCondition: ({ selectedAccount, accountConfig }) =>
                isFeatureAllowedForICPAccount(selectedAccount, accountConfig, FEATURE_FLAGS.IS_DISPLAY_FILTERS_ENABLED),
        },
        {
            id: FILTER_TYPE.CAMPAIGN_ITEM_ORIENTATION,
        },
        {
            id: FILTER_TYPE.CREATIVE_LIBRARY_SIZE,
            multiSelect: true,
            visibilityCondition: ({ selectedAccount, accountConfig }) =>
                isFeatureAllowedForICPAccount(selectedAccount, accountConfig, FEATURE_FLAGS.IS_DISPLAY_FILTERS_ENABLED),
        },
    ],
    initialFilters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            type: FILTER_TYPE.TOP_RESULTS,
            values: [{ value: TOP_RESULTS_TYPE.TOP200, label: 'Top 200', messageId: 'report.topResults.200' }],
            accountConfigurations: {
                [FEATURE_FLAGS.HEAVY_ACCOUNT]: 'false',
                [FEATURE_FLAGS.CREATIVE_REPORT_TOP_RESULTS_FILTER_ACTIVE]: 'true',
                [FEATURE_FLAGS.CREATIVE_REPORT_USE_WIDE_CONFIG_MSV2]: 'false',
            },
        },
    ],
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    defaultGridSort: [
        {
            colId: generateColumnId(CREATIVE_LIBRARY_REPORT_ID, FIELDS.CREATE_TIME.field),
            sort: SORTING_ORDER_TYPES.DESCENDANT,
        },
    ],
    customPreset: { columns: defaultColumns, initialState: defaultColumns },
    rowHeight: 86,
    isLegalDisclaimerVisible: false,
};
